import { render, staticRenderFns } from "./msw-issue-list.vue?vue&type=template&id=43c30b8a&scoped=true&"
import script from "./msw-issue-list.vue?vue&type=script&lang=tsx&"
export * from "./msw-issue-list.vue?vue&type=script&lang=tsx&"
import style0 from "./msw-issue-list.vue?vue&type=style&index=0&id=43c30b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c30b8a",
  null
  
)

export default component.exports